import React, { useState, useEffect } from "react";
import "react-alice-carousel/lib/alice-carousel.css";
import {
    Button,
    Grid,
    Typography,
    Card,
    CardHeader,
    FormControl,
    Select,
    InputLabel,
    MenuItem,
    TextField,
    Dialog, DialogActions, DialogContent, DialogTitle,
    CardContent,
    Box,
    IconButton,
    Tooltip,
    CircularProgress,
} from "@mui/material";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { getVendors } from "../../State/Vendor/Action";
import { DataGrid } from "@mui/x-data-grid";
import "../Size/AddSize.css"
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import { Delete, Edit, FileDownload, PictureAsPdf, Print, UploadFile } from '@mui/icons-material';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { PermissionService } from "../../../config/permissionService";
import { getSelectedExportRows } from "../../../config/exportSelection";
import { createDesignerDiscountBanner, deleteDesignerDiscountBanner, updateDesignerDiscountBanner, getAllDesignerDiscountBanner } from "../../State/DesignerDiscountBanner/Action";
import ImagePopup from "../../../Common/ImagePopup";

const DesignerOnDiscount = () => {
    const { designerDiscountBanners, adminVendor } = useSelector((store) => store);
    const dispatch = useDispatch();
    const [bannerData, setBannerData] = useState({
        vendorId: "",
        discountPercentage: "",
        startDate: "",
        endDate: "",
    });
    const [selectedImageFile, setSelectedImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState(null);
    const [uploadedImage, setUploadedImage] = useState(null);
    const [editingId, setEditingId] = useState(null);
    const [vendorId, setVendorId] = useState(null)
    const [openAddBannerModal, setOpenAddBannerModal] = useState(false);

  const [selectedRowIds, setSelectedRowIds] = useState([]);
    const [openConfirm, setOpenConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const fileInputRef = React.useRef(null);
    const [error, setError] = useState("");
    const [imageOpen, setImageOpen] = useState(false);
    const [imageUrl, setImageUrl] = useState("");

    // Get current date and time in YYYY-MM-DDTHH:mm format
    const todayDateTime = dayjs().format("YYYY-MM-DDTHH:mm");

    useEffect(() => {
        dispatch(getVendors())
        dispatch(getAllDesignerDiscountBanner())
    }, [dispatch]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBannerData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (!selectedFile) return;

        const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
        if (!allowedTypes.includes(selectedFile.type)) {
            setError("Only JPG, JPEG, and PNG images are allowed!");
            setSelectedImageFile(null);
            setImagePreview(null);
            return;
        }

        setError("");
        setSelectedImageFile(selectedFile);
        setImagePreview(URL.createObjectURL(selectedFile));

        // Reset the file input so same file can be uploaded again
        if (fileInputRef.current) {
            fileInputRef.current.value = null;
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (
            !bannerData.discountPercentage ||
            !bannerData.startDate ||
            !bannerData.endDate
        ) {
            toast.error("All fields are required");
            return;
        }

        if (bannerData.discountPercentage <= 0) {
            toast.error("Discount percentage must be greater than 0");
            return;
        }

        if (bannerData.endDate <= bannerData.startDate || bannerData.endDate <= todayDateTime) {
            toast.error("End date must be after the start date & Future minute!");
            return;
        }

        if (!vendorId) {
            toast.error("Please select a Vendor");
            return;
        }

        const formData = new FormData();
        if (selectedImageFile) {
            formData.append("imageFile", selectedImageFile); // ✅ match backend key
        }
        const formattedata = {
            ...bannerData,
            vendorId: vendorId,
            startDate: dayjs(bannerData.startDate).format("YYYY-MM-DDTHH:mm:ss"),
            endDate: dayjs(bannerData.endDate).format("YYYY-MM-DDTHH:mm:ss"),
        };

        if (editingId) {
            dispatch(updateDesignerDiscountBanner(editingId, formattedata, formData, handleCancle));
        } else {
            if (bannerData.startDate <= todayDateTime) {
                toast.error("Start date must be in the future Minute");
                return;
            }
            if (!selectedImageFile) {
                toast.error("Please upload an image");
                return;
            }
            dispatch(createDesignerDiscountBanner(formattedata, formData, handleCancle));
        }

    };

    const handleBannerUpdate = (item) => {
        setBannerData({
            vendorId: item.vendor?.id || "",
            discountPercentage: item.discountPercentage,
            startDate: dayjs(item.startDate).format("YYYY-MM-DDTHH:mm"),
            endDate: dayjs(item.endDate).format("YYYY-MM-DDTHH:mm"),
        });
        setSelectedImageFile(null);
        setUploadedImage(item.imageUrl);
        setEditingId(item.id);
        setOpenAddBannerModal(true);
        setVendorId(item.vendor?.id);
    };

    const handleDelete = () => {
        dispatch(deleteDesignerDiscountBanner(deleteId));
        setOpenConfirm(false);
        setDeleteId(null);
    };


    const handleCancle = () => {
        setBannerData({
            vendorId: "",
            discountPercentage: "",
            startDate: "",
            endDate: "",
        });
        setVendorId(null);
        setSelectedImageFile(null);
        setImagePreview(null);
        setUploadedImage(null);
        setEditingId(null);
        setOpenAddBannerModal(false);
        setError("")
    }

    const writeAction = PermissionService.has({ category: "Admin", page: "Designer On Discounts", type: "WRITE" });

    // Define columns
    const bannerColumns = [
        {
            field: "serialNo",
            headerName: "S.No.",
            width: 80,
            sortable: false,
            renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1
        },
        { field: "vendor", headerName: "Vendor", flex: 1 },
        { field: "discountPercentage", headerName: "Discount", width: 100, renderCell: (params) => `${params?.value}%` },
        { field: "startDate", headerName: "From Date & Time", flex: 1, renderCell: (params) => params.value ? dayjs(params?.value).format("DD MMM YYYY HH:mm") : "----", },
        { field: "endDate", headerName: "To Date & Time", flex: 1, renderCell: (params) => params.value ? dayjs(params?.value).format("DD MMM YYYY HH:mm") : "----", },
        {
            field: "image",
            headerName: "Image",
            flex: 1.5,
            renderCell: (params) => (
                <img
                    onClick={() => { setImageOpen(true); setImageUrl(params?.value) }} className="cursor-pointer"
                    src={params.value}
                    alt="Banner"
                    style={{ width: 50, height: 50, borderRadius: 4 }}
                />
            ),
        },
        ...(writeAction ? [
            {
                field: "actions",
                headerName: "Action",
                width: 120,
                sortable: false,
                renderCell: (params) => (
                    <Box display="flex" gap={0} sx={{ p: 0, m: 0, minHeight: 0 }}>
                        <Tooltip title="Edit">
                            <IconButton
                                size="small"
                                sx={{ p: 0, m: 0, minWidth: 24, minHeight: 24, cursor: "pointer" }}
                                onClick={() => handleBannerUpdate(params.row.banner)}
                            >
                                <Edit fontSize="small" sx={{ fontSize: 15, cursor: "pointer" }} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Delete">
                            <IconButton
                                color="error"
                                size="small"
                                sx={{ p: 0, m: 0, minWidth: 24, minHeight: 24, cursor: "pointer" }}
                                onClick={() => {
                                    setDeleteId(params.row.id);
                                    setOpenConfirm(true);
                                }}
                            >
                                <Delete fontSize="small" sx={{ fontSize: 15, cursor: "pointer" }} />
                            </IconButton>
                        </Tooltip>
                    </Box>
                )
            }
        ] : []),
    ];


    const bannerRows =
        designerDiscountBanners.designerDiscountBanners?.response?.map((item) => ({
            id: item.id,
            vendor: item.vendor?.name || "----",
            discountPercentage: item.discountPercentage || 0,
            startDate: item.startDate,
            endDate: item.endDate,
            image: item.imageUrl,
            banner: item
        })) || [];

    const [searchText, setSearchText] = useState("");

    const filteredBannerRows = bannerRows.filter(row => {
        const query = searchText.toLowerCase();
        return (
            row.vendor.toLowerCase().includes(query) ||
            String(row.discountPercentage).toLowerCase().includes(query) ||
            row.startDate.toLowerCase().includes(query) ||
            row.endDate.toLowerCase().includes(query)
        );
    });

      const getExportData = () => getSelectedExportRows(filteredBannerRows, selectedRowIds);

  const handleExportCSV = () => {
    const exportRows = getExportData();
    if (!exportRows) return;
        const csvContent = exportRows.map((row, index) => [index + 1,
        row.vendor, `${row.discountPercentage}%`,
        row.startDate ? dayjs(row.startDate).format("DD MMM YYYY HH:mm") : "----",
        row.endDate ? dayjs(row.endDate).format("DD MMM YYYY HH:mm") : "----",
        ].join(',')).join('\n');
        const headers = ['S.No.', 'Vendor', 'Discount',
            'From Date',
            'To Date',].join(',');
        const csv = `${headers}\n${csvContent}`;
        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'designerDiscountBanners.csv';
        link.click();
    };
    const handleExportPDF = () => {
      const exportRows = getExportData();
      if (!exportRows) return;
        const doc = new jsPDF();
        doc.setFontSize(12);
        doc.text("Banner List", 14, 15);
        const tableColumn = ['S.No.', 'Vendor', 'Discount',
            'From Date',
            'To Date',];
        const tableRows = exportRows.map((row, index) => [index + 1, row.vendor, `${row.discountPercentage}%`,
        row.startDate ? dayjs(row.startDate).format("DD MMM YYYY HH:mm") : "----",
        row.endDate ? dayjs(row.endDate).format("DD MMM YYYY HH:mm") : "----",]);
        autoTable(doc, {
            head: [tableColumn],
            body: tableRows,
            startY: 20,
            theme: 'striped',
            headStyles: {
                fillColor: [37, 99, 235], // Tailwind blue-600 (RGB: 37,99,235)
                textColor: [255, 255, 255], // white text
                halign: 'left',
            },
            styles: { fontSize: 8, cellPadding: 1, overflow: 'linebreak' },
        });
        doc.save('designerDiscountBanners.pdf');
    };
    const handlePrint = () => {
      const exportRows = getExportData();
      if (!exportRows) return;
        const printWindow = window.open('', '_blank');
        const headers = ['S.No.', 'Vendor', 'Discount',
            'From Date',
            'To Date',];
        const tableContent = exportRows.map((row, index) => [index + 1, row.vendor, `${row.discountPercentage}%`,
        row.startDate ? dayjs(row.startDate).format("DD MMM YYYY HH:mm") : "----",
        row.endDate ? dayjs(row.endDate).format("DD MMM YYYY HH:mm") : "----",]);
        const html = `
      <html>
        <head>
          <title>Banner List</title>
          <style>
            table { border-collapse: collapse; width: 100%; }
            th, td { border: 1px solid black; padding: 8px; text-align: left; }
            th {background: #449AEF;
                color: white;
                -webkit-print-color-adjust: exact;
                print-color-adjust: exact; }
            tr:nth-child(even) { background-color: #f5f5f5; }
          </style>
        </head>
        <body>
          <h2>Banner List</h2>
          <table>
            <thead>
              <tr>
                ${headers.map(header => `<th>${header}</th>`).join('')}
              </tr>
            </thead>
            <tbody>
              ${tableContent.map(row => `
                <tr>
                  ${row.map(cell => `<td>${cell}</td>`).join('')}
                </tr>
              `).join('')}
            </tbody>
          </table>
        </body>
      </html>
    `;
        printWindow.document.write(html);
        printWindow.document.close();
        printWindow.print();
    };


    return (
        <div className="relative">
            <Card className="p-3" sx={{ borderRadius: 2, boxShadow: 1 }}>
                <CardHeader
                    title={
                        <Typography variant="h6" className="text-gray-700">
                            DESIGNER ON DISCOUNT BANNERS
                        </Typography>
                    }
                    action={writeAction && (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <IconButton
                                sx={{
                                    background: "linear-gradient(90deg, #449AEF 0%, #f87171 100%)",
                                    color: "#fff",
                                    boxShadow: "0 2px 8px rgba(239,68,68,0.15)",
                                    transition: "all 0.2s",
                                    "&:hover": {
                                        background: "linear-gradient(90deg, #f87171 0%, #449AEF 100%)",
                                        boxShadow: "0 4px 16px rgba(239,68,68,0.25)",
                                        transform: "scale(1.02)",
                                    },
                                    cursor: "pointer",
                                    p: 1,
                                    borderRadius: '50%',
                                }}
                                onClick={() => {
                                    setOpenAddBannerModal(true);
                                    setEditingId(null);
                                }}
                            >
                                <AddIcon />
                            </IconButton>
                            <Typography
                                variant="subtitle1"
                                sx={{ fontWeight: 700, color: "#449AEF", fontSize: "1.2rem", letterSpacing: 0.2 }}
                            >
                                Add Designer Discount Banner
                            </Typography>
                        </Box>
                    )}
                />
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', mb: 2 }}>
                    <Box sx={{ display: 'flex', gap: 1.5, mb: { xs: 2, sm: 0 } }}>
                        <Button
                            variant="contained"
                            startIcon={<FileDownload />}
                            onClick={handleExportCSV}
                            sx={{
                                background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                                color: '#fff',
                                fontWeight: 600,
                                fontSize: '0.85rem',
                                borderRadius: '6px',
                                px: 2,
                                py: 0.8,
                                transition: 'all 0.2s',
                                '&:hover': {
                                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                                    transform: 'scale(1.02)',
                                },
                                cursor: 'pointer',
                                width: { xs: '100%', sm: 'auto' },
                            }}
                        >
                            Export CSV
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<PictureAsPdf />}
                            onClick={handleExportPDF}
                            sx={{
                                background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                                color: '#fff',
                                fontWeight: 600,
                                fontSize: '0.85rem',
                                borderRadius: '6px',
                                px: 2,
                                py: 0.8,
                                transition: 'all 0.2s',
                                '&:hover': {
                                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                                    transform: 'scale(1.02)',
                                },
                                cursor: 'pointer',
                                width: { xs: '100%', sm: 'auto' },
                            }}
                        >
                            Export PDF
                        </Button>
                        <Button
                            variant="contained"
                            startIcon={<Print />}
                            onClick={handlePrint}
                            sx={{
                                background: 'linear-gradient(90deg, #592545 0%, #a63f7b 100%)',
                                color: '#fff',
                                fontWeight: 600,
                                fontSize: '0.85rem',
                                borderRadius: '6px',
                                px: 2,
                                py: 0.8,
                                transition: 'all 0.2s',
                                '&:hover': {
                                    background: 'linear-gradient(90deg, #a63f7b 0%, #592545 100%)',
                                    boxShadow: '0 4px 12px rgba(89,37,69,0.2)',
                                    transform: 'scale(1.02)',
                                },
                                cursor: 'pointer',
                                width: { xs: '100%', sm: 'auto' },
                            }}
                        >
                            Print
                        </Button>
                    </Box>
                    <Box>
                        <TextField
                            label="Search Banners"
                            variant="outlined"
                            size="small"
                            value={searchText}
                            onChange={e => setSearchText(e.target.value)}
                            sx={{ width: { xs: '100%', sm: '300px' } }}
                        />
                    </Box>
                </Box>
                <Box sx={{ height: `calc(100vh - 250px)`, width: "100%" }}>
                    <DataGrid
                        rows={filteredBannerRows}
                        columns={bannerColumns}
                        getRowId={(row) => row.id}
                        pagination
                        initialState={{
                            pagination: { paginationModel: { pageSize: 10, page: 0 } },
                        }}
                        pageSizeOptions={[10, 25, 50, 75, 100]}
                                    checkboxSelection
                        onRowSelectionModelChange={(ids) => setSelectedRowIds(ids)}
                        rowSelectionModel={selectedRowIds}
                        disableSelectionOnClick
                        density="compact"
                        experimentalFeatures={{ virtualization: true }}
                        loading={designerDiscountBanners.loading}
                        autoHeight={true}
                        sx={{
                            borderRadius: 2,
                            fontSize: "0.8rem",
                            "& .MuiDataGrid-cell": {
                                fontSize: "0.8rem",
                                border: "1px solid rgb(204, 201, 201)",
                                minHeight: "36px !important",
                                height: "36px !important",
                                lineHeight: "1.2",
                                paddingTop: "4px",
                                paddingBottom: "4px",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            },
                            "& .MuiDataGrid-columnHeader": {
                                backgroundColor: "#449AEF",
                                color: "#fff",
                                fontWeight: "bold",
                                fontSize: "0.8rem",
                                padding: "8px",
                                border: "1px solid rgb(204, 201, 201)",
                                minHeight: "36px !important",
                                height: "36px !important",
                                lineHeight: "1.2",
                            },
                            "& .MuiDataGrid-columnHeaderTitle": {
                                fontSize: "0.8rem",
                                fontWeight: 600,
                            },
                            "& .MuiDataGrid-row": {
                                maxHeight: "36px !important",
                                minHeight: "36px !important",
                            },
                            "& .MuiDataGrid-row:nth-of-type(odd)": {
                                backgroundColor: "#f5f5f5",
                            },
                            "& .MuiDataGrid-row:nth-of-type(even)": {
                                backgroundColor: "#ffffff",
                            },
                            "& .MuiDataGrid-row:hover": {
                                backgroundColor: "#f5f5f5",
                            },
                        }}
                    />
                </Box>
            </Card>

            {/* Replace the form rendering with a Dialog: */}
            <Dialog
                open={openAddBannerModal}
                onClose={handleCancle}
                fullWidth
                maxWidth="sm"
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        fontSize: '1.25rem',
                        fontWeight: 'bold',
                        mt: 1,
                        mb: 0.5,
                        pb: 1,
                        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                    }}
                >
                    Designer Discount Banner
                    <IconButton onClick={handleCancle} size="small" sx={{ ml: 2 }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ px: 2, py: 1 }}>
                    <Card className="mb-2 mt-2" sx={{ borderRadius: 2, boxShadow: 1 }}>
                        <CardContent sx={{ p: 1 }}>
                            <form onSubmit={handleSubmit}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <FormControl fullWidth>
                                            <InputLabel id="vendor-label">Select Vendor</InputLabel>
                                            <Select
                                                labelId="vendor-label"
                                                label="Select Vendor"
                                                value={vendorId}
                                                onChange={(e) => setVendorId(e.target.value)}
                                            >
                                                <MenuItem value={""} disabled>
                                                    Select Vendor...
                                                </MenuItem>
                                                {adminVendor?.vendors?.response?.map(
                                                    (vendor) =>
                                                        vendor && (
                                                            <MenuItem key={vendor.id} value={vendor.id}>
                                                                {vendor.name}
                                                            </MenuItem>
                                                        )
                                                )}
                                            </Select>
                                        </FormControl>
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label="Discount Percentage"
                                            name="discountPercentage"
                                            value={bannerData.discountPercentage}
                                            onChange={handleChange}
                                            inputProps={{ maxLength: 2 }}
                                            variant="outlined"
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    transition: "all 0.2s ease-in-out",
                                                    "&:hover fieldset": {
                                                        borderColor: "#449AEF",
                                                    },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: "#449AEF",
                                                    },
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label="From Date & Time"
                                            name="startDate"
                                            type="datetime-local"
                                            value={bannerData.startDate}
                                            onChange={handleChange}
                                            InputLabelProps={{ shrink: true }}
                                            variant="outlined"
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    transition: "all 0.2s ease-in-out",
                                                    "&:hover fieldset": {
                                                        borderColor: "#449AEF",
                                                    },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: "#449AEF",
                                                    },
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={6}>
                                        <TextField
                                            fullWidth
                                            label="To Date & Time"
                                            name="endDate"
                                            type="datetime-local"
                                            value={bannerData.endDate}
                                            onChange={handleChange}
                                            InputLabelProps={{ shrink: true }}
                                            inputProps={{ min: bannerData.startDate }}
                                            variant="outlined"
                                            sx={{
                                                "& .MuiOutlinedInput-root": {
                                                    transition: "all 0.2s ease-in-out",
                                                    "&:hover fieldset": {
                                                        borderColor: "#449AEF",
                                                    },
                                                    "&.Mui-focused fieldset": {
                                                        borderColor: "#449AEF",
                                                    },
                                                },
                                            }}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12}>
                                        {/* Wrap everything inside a vertical Box */}
                                        <Box>
                                            <Button
                                                variant="outlined"
                                                component="label"
                                                fullWidth
                                                sx={{ py: 1.8 }}
                                                startIcon={<UploadFile />}
                                            >
                                                Upload Image
                                                <input
                                                    type="file"
                                                    hidden
                                                    ref={fileInputRef}
                                                    accept="image/*"
                                                    onChange={handleFileChange}
                                                />
                                            </Button>

                                            {/* Error shown below the button */}
                                            {error && (
                                                <Typography color="error" variant="caption" mt={1}>
                                                    {error}
                                                </Typography>
                                            )}
                                        </Box>
                                    </Grid>

                                    {/* Uploaded Image */}
                                    {uploadedImage && (
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle1">Current Image:</Typography>
                                            <Box
                                                component="img"
                                                src={uploadedImage}
                                                alt="Uploaded"
                                                sx={{ width: "100%", maxWidth: 100, borderRadius: 2, mt: 1 }}
                                            />
                                        </Grid>
                                    )}

                                    {/* Preview */}
                                    {imagePreview && (
                                        <Grid item xs={12} sm={6}>
                                            <Typography variant="subtitle1">Image Preview:</Typography>
                                            <Box
                                                component="img"
                                                src={imagePreview}
                                                alt="Preview"
                                                sx={{ width: "100%", maxWidth: 100, borderRadius: 2, mt: 1 }}
                                            />
                                        </Grid>
                                    )}
                                    <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", gap: 2, }}>
                                        <Button
                                            variant="contained"
                                            type="submit"
                                            sx={{
                                                background: "linear-gradient(90deg, #449AEF 0%, #f87171 100%)",
                                                color: "#fff",
                                                fontWeight: 600,
                                                fontSize: "0.85rem",
                                                borderRadius: "6px",
                                                boxShadow: "0 2px 8px rgba(239,68,68,0.15)",
                                                px: 2.5,
                                                py: 0.8,
                                                transition: "all 0.2s",
                                                "&:hover": {
                                                    background: "linear-gradient(90deg, #f87171 0%, #449AEF 100%)",
                                                    boxShadow: "0 4px 16px rgba(239,68,68,0.25)",
                                                    transform: "scale(1.02)",
                                                },
                                                width: { xs: "100%", sm: "auto" },
                                                textAlign: "center"
                                            }}
                                        >
                                            {designerDiscountBanners.loading ? (
                                                <>
                                                    <CircularProgress size={20} sx={{ mr: 1 }} />
                                                    Processing...
                                                </>
                                            ) : (editingId ? "Update Discount Banner" : "Add Discount Banner")}
                                        </Button>
                                        <Button
                                            variant="outlined"
                                            onClick={handleCancle}
                                            sx={{
                                                color: "#449AEF",
                                                borderColor: "#449AEF",
                                                fontWeight: 600,
                                                fontSize: "0.85rem",
                                                borderRadius: "6px",
                                                px: 2.5,
                                                py: 0.8,
                                                mt: 1,
                                                transition: "all 0.2s",
                                                "&:hover": {
                                                    backgroundColor: "#449AEF",
                                                    color: "#fff",
                                                    borderColor: "#449AEF",
                                                    boxShadow: "0 2px 8px rgba(239,68,68,0.1)",
                                                },
                                                width: { xs: "100%", sm: "auto" },
                                                textAlign: "center"
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                    </Grid>

                                </Grid>
                            </form>
                        </CardContent>
                    </Card>
                </DialogContent>
            </Dialog>
            {/* delete dialog box */}
            <Dialog open={openConfirm} onClose={() => setOpenConfirm(false)}>
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    Are you sure you want to delete this Designer On Discount Banner?
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpenConfirm(false)} color="primary">
                        Cancel
                    </Button>
                    <Button
                        onClick={() => {
                            handleDelete(deleteId);   // Call your delete function   
                        }}
                        color="error"
                    >
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
            {/* Common Popup */}
            <ImagePopup
                open={imageOpen}
                onClose={() => setImageOpen(false)}
                imageUrl={imageUrl}
            />
        </div>
    );
};

export default DesignerOnDiscount;
